import 'whatwg-fetch'

export function Util_ajaxRequest(type: string, url: string, data: any, contentType: string) {
    const options: any = {
        method: type,
        headers: { 'Content-Type': contentType },
    }
    /* Validation needed for the new fetch API since if no data exists the resquest is going to fail */
    if (data) {
        options.body = JSON.stringify(data)
    }

    return fetch(url, options).then((response) => {
        return response.json()
    })
}

export function Util_ajaxRequestNoResponse(type: string, url: string, data: any, contentType: string) {
    const options: any = {
        method: type,
        headers: { 'Content-Type': contentType },
    }
    /* Validation needed for the new fetch API since if no data exists the resquest is going to fail */
    if (data) {
        options.body = JSON.stringify(data)
    }

    fetch(url, options)
}
